/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { startProgress, stopProgress } from './progress-util.js';
import { default_ajax_error_handler, default_ajax_app_error_handler } from './fetch-util.js';
import { showSnackbar } from './snackbar.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';

import '../vendor/setImmediate.cjs';


/**
 * MTemplates - manage lazy-loading of server-rendered templates
 *
 */
export let MTemplates = function($,mj) {

	var m_queue_to = null,
		m_request_queue = [], // [ {id:id,cbs:[cb,cb,..]}, {id:id,cbs:[cb,cb,..]}, .. ]
		m_templates = {},
		m_dialog_tmpls_known = [],
		m_rq_max_slice_size = 10,
		m_page_templates_container_elem = null;



	function _bump_queue() {
		if( m_request_queue.length>0 && m_queue_to===null ) m_queue_to = window.setImmediate(_process_queue);
	}

	function _process_queue() {
		if( m_request_queue.length===0 ) return;

		// determine chunk of ids to load now ...
		var ml = m_request_queue.length < m_rq_max_slice_size ? m_request_queue.length : m_rq_max_slice_size,
			ids = [],
			cbs = {};
		for( var i=0; i<ml; ++i ) {
			var qi = m_request_queue[i];
			ids.push(qi.id);
			cbs[qi.id] = qi.cbs;
		}
		m_request_queue.splice(0,ml);

		// request chunk ...
		var getparams =  'locale='+encodeURIComponent(mj.locale)
						+'&ids='+encodeURIComponent(ids.join(','));

		// add params for cache busting
		var cb_arr = [
			mj.minify ? 'm' : '',
			mj.jsbundling ? 'b' : '',
			mj.session_is_valid ? 'v' : '',
			mj.user_oblivious ? 'o' : '',
			mj.user_id,
			mj.role_user ? 1 : 0,
			mj.role_manager ? 1 : 0,
			mj.role_administrator ? 1 : 0,
			mj.role_maintenance ? 1 : 0,
			( mj.role_versions_manager ?? false ) ? 1 : 0,
			( mj.role_versions_user ?? false ) ? 1 : 0,
		];
		getparams += '&_cb=' + encodeURIComponent(cb_arr.join(','));


		function ajax_done() {
			m_queue_to = null;
			_bump_queue();
		}
		startProgress();
		$.getJSON2( 'json/widgets/html-get', getparams, true,
			function mtemplates_load_success(j) {
				stopProgress();
				if( j.error ) {
					default_ajax_app_error_handler(j.error,j);
				} else if( j.success ) {
					for( var i=0; i<ids.length; ++i ) {
						var id = ids[i];
						if( !j.html[id] ) {
							showSnackbar('failed to load template id='+id);
							continue;
						}
						var html = j.html[id];
						m_templates[id] = html;
						if( cbs[id] ) {
							var cl = cbs[id].length;
							for( var c=0; c<cl; ++c ) {
								var cb = cbs[id][c];
								cb(id,html);
							}
						}
					}
				}
				ajax_done();
			}, function mtemplates_load_timeout() {
				stopProgress();
				showSnackbar('timeout while loading templates from server');
				ajax_done();
			}, function mtemplates_load_error(jqXHR,textStatus,message) {
				default_ajax_error_handler(jqXHR,textStatus,message);
				ajax_done();
			}, false );
	}

	function queryTemplateHTML( id, ondone ) {
		if( m_templates[id] ) {
			ondone(id,m_templates[id]);
		} else {
			var found = false;
			for( var i=0; i<m_request_queue.length; ++i ) {
				if( m_request_queue[i].id===id ) {
					m_request_queue[i].cbs.push(ondone);
					found = true;
					break;
				}
			}
			if( !found ) m_request_queue.push( {'id':id,'cbs':[ondone]} );
			_bump_queue();
		}
	}

	function queryDialogHTML( id, ondone ) {
		if( m_dialog_tmpls_known.indexOf(id)!==-1 ) {
			ondone(id);
		} else {
			queryTemplateHTML( id, function mvtemplates_queryTemplateHTML_done(id,html) {
				// create a hidden div as a container for all dynamically loaded dialog elements..
				if( m_page_templates_container_elem===null ) m_page_templates_container_elem = $('<div id="page-templates-container" style="display:none"></div>').insertBefore('#page-blocking-overlay');
				m_page_templates_container_elem.append(html);
				m_dialog_tmpls_known.push(id);
				m_templates[id] = ''; // actual html is not required anymore !
				ondone(id);
			} );
		}
	}

	function queryDialogHTMLWrappedFn( id, fn ) {
		return function queryDialogHTMLWrappedFn_wrapper() {
			var wrappedThis = this,
				args = Array.prototype.slice.call(arguments);
			queryDialogHTML( id, function queryDialogHTML_loaded( id ) {
				fn.apply(wrappedThis,args);
			} );
		};
	}

	function queryDialogHTMLWrappedFn2( ids, fn ) {
		return function queryDialogHTMLWrappedFn2_wrapper() {
			var wrappedThis = this,
				args = Array.prototype.slice.call(arguments),
				loaded_count = 0;
			for( var i=0; i<ids.length; ++i ) {
				var id = ids[i];
				queryDialogHTML( id, function queryDialogHTML_loaded2( id ) {
					if( ++loaded_count === ids.length ) {
						fn.apply(wrappedThis,args);
					}
				} );
			}
		};
	}

	return {
		queryTemplateHTML: queryTemplateHTML,

		queryDialogHTML: queryDialogHTML,

		queryDialogHTMLWrappedFn: queryDialogHTMLWrappedFn,
		queryDialogHTMLWrappedFn2: queryDialogHTMLWrappedFn2,
	};

}(jQuery,mj); // namespace MTemplates
